<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import SourceCleanupInstructionsCell from "./_modules/source-cleanup-instructions-cell"
  import type { CustomerSourceCleanupDraft, CustomerSourceCleanupRow } from "../../contract"

  let props: InboxWorkflowCellProps<CustomerSourceCleanupRow, CustomerSourceCleanupDraft> = $props()

  const row = $derived(props.row)
</script>

<SourceCleanupInstructionsCell
  instructions={row.sourceSyncInstructions}
  disabled={props.disabled}
/>
